
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';


import { Link } from "react-router-dom";
import nemet from "../../assets/nemet.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function NemetMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Német magyar fordító</title>
                <meta name='description' content="Ingyenes német magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Német magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/nemet-magyar-fordito" />
            </Helmet>
            <h1>Német magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A német nyelvről</h2>
                    <img src={nemet} alt="Német zászló"></img>
                </div>

                <p>A német vagy német nyelv egy nyugat-német nyelv, amelyet elsősorban Németországban, Ausztriában, Svájcban és Liechtensteinben beszélnek. Világszerte beszélik német nyelvű közösségek is, és az Európai Unió egyik hivatalos nyelve. A német nyelv gazdag irodalmi és filozófiai hagyományairól, valamint a tudományhoz és a technológiához való hozzájárulásáról ismert.</p>

                <p>A német írásrendszer a latin ábécét használja, néhány további karakterrel és diakritikus jelekkel kiegészítve. 26 betűből áll, beleértve az umlautokat (ä, ö, ü) és az Eszett (ß) betűket. A német kiejtés általában egységes és fonetikus, néhány kivételtől és regionális eltéréstől eltekintve.</p>

                <p>Nyelvtana a főnevek deklinációjának, az igék ragozásának és a nyelvtani nemeknek bonyolult rendszerét tartalmazza. A főnevek, melléknevek és elöljárók alakja eset, szám és nem szerint változik. A német nyelvben négy eset (nominativus, akkuzatív, dativus és genitivus) jelöli a nyelvtani kapcsolatokat, valamint három nem (hímnem, nőnem és semleges).</p>

                <p>Szókincse germán eredetű szavakat, valamint más nyelvekből, különösen az angolból, franciából és latinból származó kölcsönszavakat tartalmaz. A német nyelv híres arról, hogy képes összetett szavakat alkotni több szó egybeolvasztásával, ami lehetővé teszi összetett és leíró kifejezések létrehozását.</p>

                <p>A német kultúra gazdag történelemben, művészetben, filozófiában és zenében. A német nyelv tanulása hozzáférést biztosít olyan írók befolyásos irodalmi műveihez, mint Johann Wolfgang von Goethe, Friedrich Schiller és Thomas Mann. Olyan gondolkodók filozófiai hagyományaiba is betekintést nyújt, mint Immanuel Kant és Friedrich Nietzsche.</p>

                <p>A nyelv ismerete számos lehetőséget nyit meg. Németország Európa legnagyobb gazdaságával rendelkezik, és számos iparágban, például az autóiparban, a gyógyszeriparban és a megújuló energiában világelső. A német nyelv ismerete előnyös lehet az üzleti, tudományos, technológiai és tudományos karrierben.</p>

                <p>A német nyelvet a szomszédos országokban is széles körben beszélik, így hasznos lehet az utazásokhoz és a közép-európai kultúrában való elmerüléshez. Emellett Németországban nagy hagyománya van a felsőoktatásnak, ami vonzza a nemzetközi diákokat az egyetemekre és kutatóintézetekbe.</p>

                <div className="sectionbottom">
                    <Link to="/magyar-nemet-fordito">Magyar német fordító</Link>

                    <img src={nemet} alt="német zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>
            </section>
        </>

    )
}

export default NemetMagyar;